import Script from "next/script";

const ReduxLoader = () => {
  return (
    <Script
      strategy="afterInteractive"
      src="https://public.reduxpayments.com/redux-payments.min.js"
      defer
    />
  );
};

export default ReduxLoader;
